<template>
  <div :class="['drag-handle md-18 material-icons',pos,{'ui-hidden':hideGlobalUI}]">drag_indicator</div>
</template>

<script>
import { mapState } from 'vuex'

export default {

  name: 'DragHandle',
  props : {
    'pos' : {
      type: String,
      default : 'right'
    }
  },
  data () {return {} },
  computed : {
    ...mapState(['hideGlobalUI'])
  },
}
</script>

<style lang="scss">
.drag-handle {
  position:absolute;
  top:50%;
  color:gray;
  width:20px;
  height:20px;
  line-height:20px;
  text-align:center;
  border-radius:100%;
  cursor:move;
  transform:translateY(-50%);
  &.right {
    right:-20px;    
  }
  &.left {
    left:-20px;    
  }
  &.ui-hidden {
    display:none;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/UI/DragHandle.vue